export class SoilScoutTokenRefresh {

    constructor(refreshToken: string) {
        this.refresh = refreshToken;
    }

    refresh: string;

}
